import { useState, useEffect, useCallback } from "react";
import "./Location.scss";

import "leaflet/dist/leaflet.css";

import WhiteLogo from "../../assets/images/WhiteLogo.png";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import MarkerIcon from "./MarkerIcon";

import {
  getPageContent
} from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";
import { Image } from "react-bootstrap";


const Location = (props) => {
  const { hostLanguage } = useLangContext();
  const [ contentDetails, setContentDetails ] = useState();
  const getAllPageContent = useCallback(async () => {
    try {
      let apiRes = await getPageContent(hostLanguage, "locations_page_data_location");
      let responseData = await apiRes.json();
      if (responseData.res) {
        setContentDetails(responseData.data);
      } else {
        console.error(responseData.msg);
      }
    } catch (error) {
      console.error(error);
    }
  },[hostLanguage]);

  useEffect(() => {
    getAllPageContent();
  }, [getAllPageContent]);

  return (
    <div className="LocationGrid">
      <Row>
        <Col sm={12} md={6}>
          <div className="image">
            <Image src={props.item.image64 === "" ? WhiteLogo : props.item.image64} alt={contentDetails?.locations_page_data_location?.title}/>
          </div>
        </Col>
        <Col sm={12} md={6}>
          <div className="description">
            <h3>
              {contentDetails?.locations_page_data_location?.title}
              <br />
              <strong>{props.item.name}</strong>
            </h3>
            <p>{contentDetails?.locations_page_data_location?.description}</p>
            <Link to={`/geschaeftsadresse/${props.item.key}`}>
              {contentDetails?.locations_page_data_location?.button}
              {props.item.name}
            </Link>
          </div>
        </Col>
      </Row>
      {(props.position !== undefined && props.position !== null && props.position?
        <Row>
          <Col sm={12}>
            <MapContainer
              center={props.position}
              zoom={13}
              scrollWheelZoom={false}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={props.position} icon={MarkerIcon}></Marker>
            </MapContainer>
          </Col>
        </Row>
      :
        <></>
      )}
    </div>
  );
};

export default Location;
